import { Icon } from "@iconify/react";
import fluentEmojiFileFolder from "@iconify-icons/fluent-emoji-flat/file-folder";

/** Bundled `fluent-emoji-flat:file-folder` — no CDN fetch at runtime. */
export function FluentEmojiFileFolderIcon(props: { size?: number }) {
  const { size = 22 } = props;
  return <Icon icon={fluentEmojiFileFolder} width={size} height={size} aria-hidden />;
}
